import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '接口功能',
    type: 'LSI_SF',
}
